// Shared by the creator UI and backend. No submitted values are persisted here.
const W9_VERSION = 'substitute-w9-2024-v1';
const W9_CERTIFICATION = `Under penalties of perjury, I certify that:
1. The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me); and
2. I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and
3. I am a U.S. citizen or other U.S. person (defined in the IRS instructions); and
4. The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.`;
const TAX_CLASSES = ['Individual/sole proprietor', 'C corporation', 'S corporation', 'Partnership', 'Trust/estate', 'LLC (C)', 'LLC (S)', 'LLC (P)', 'Other'];
const W9_FIELDS = [
  ['name', 'Name (as shown on your tax return)', 100], ['businessName', 'Business/disregarded entity name (if different)', 100, true],
  ['otherClass', 'Other classification (if selected)', 80, true], ['address', 'Street address, apartment or suite', 160],
  ['city', 'City', 80], ['state', 'State (two letters)', 2], ['zip', 'ZIP code', 10],
  ['exemptPayeeCode', 'Exempt payee code (optional)', 2, true], ['fatcaCode', 'FATCA exemption code (optional)', 1, true],
  ['accountReference', 'Optional account reference (not bank details)', 80, true], ['tin', 'SSN, ITIN or EIN (9 digits)', 11],
];
const BANK_FIELDS = [
  ['accountHolder', 'Account holder / legal payee name', 100], ['bankName', 'Bank name', 100],
  ['accountNumber', 'Account number', 17], ['routingNumber', 'ACH routing number', 9, true],
  ['wireRoutingNumber', 'Domestic wire routing number (if using wire)', 9, true],
  ['bankAddress', 'Bank address (required for wire)', 180, true],
];
function routingValid(value) {
  if (!/^\d{9}$/.test(value) || /^0+$/.test(value)) return false;
  const prefix = Number(value.slice(0, 2));
  return (prefix <= 12 || (prefix >= 21 && prefix <= 32) || (prefix >= 61 && prefix <= 72) || prefix === 80)
    && [...value].reduce((sum, digit, index) => sum + Number(digit) * [3, 7, 1][index % 3], 0) % 10 === 0;
}
function validateForm(purpose, input) {
  if (!input || typeof input !== 'object' || Array.isArray(input)) throw new Error('invalid-form');
  const fields = purpose === 'w9' ? W9_FIELDS : BANK_FIELDS;
  const data = {};
  for (const [key, , max, optional] of fields) {
    const raw = input[key] == null ? '' : input[key];
    // Standard PDF fonts cover Latin-1. Other scripts use the official uploaded form.
    if (typeof raw !== 'string' || raw.length > max || /[^\x20-\x7e\xa0-\xff]/.test(raw)) throw new Error('invalid-form');
    data[key] = raw.trim();
    if (!optional && !data[key]) throw new Error('incomplete-form');
  }
  if (purpose === 'w9') {
    if (input.formVersion !== W9_VERSION || !TAX_CLASSES.includes(input.taxClass)) throw new Error('invalid-tax-classification');
    data.taxClass = input.taxClass;
    data.tinType = input.tinType;
    data.tin = data.tin.replace(/[- ]/g, '');
    if (!['SSN/ITIN', 'EIN'].includes(data.tinType) || !/^\d{9}$/.test(data.tin) || /^0+$/.test(data.tin)) throw new Error('invalid-tax-id');
    if (!/^[A-Z]{2}$/.test(data.state) || !/^\d{5}(-\d{4})?$/.test(data.zip)) throw new Error('invalid-address');
    if (data.taxClass === 'Other' && !data.otherClass) throw new Error('incomplete-classification');
    if (data.exemptPayeeCode && (!/^(?:[1-9]|1[0-3])$/.test(data.exemptPayeeCode) || data.taxClass === TAX_CLASSES[0])) throw new Error('invalid-exemption');
    if (data.fatcaCode && !/^[A-M]$/.test(data.fatcaCode)) throw new Error('invalid-exemption');
    if (typeof input.confirmNumber !== 'string' || input.confirmNumber.replace(/[- ]/g, '') !== data.tin) throw new Error('tax-id-confirmation-mismatch');
    if (input.usPerson !== true || input.noBackupWithholding !== true) throw new Error('use-official-tax-form');
    data.formVersion = W9_VERSION;
  } else {
    data.method = input.method; data.accountType = input.accountType;
    if (!['ach', 'wire'].includes(data.method) || !['checking', 'savings'].includes(data.accountType)) throw new Error('invalid-bank-method');
    if (input.confirmNumber !== data.accountNumber) throw new Error('account-confirmation-mismatch');
    if (!/^\d{4,17}$/.test(data.accountNumber) || /^0+$/.test(data.accountNumber)) throw new Error('invalid-bank-details');
    if ((data.method === 'ach' && !routingValid(data.routingNumber)) || (data.routingNumber && !routingValid(data.routingNumber))) throw new Error('invalid-ach-routing');
    if (data.wireRoutingNumber && !routingValid(data.wireRoutingNumber)) throw new Error('invalid-wire-routing');
    if (data.method === 'wire' && (!data.wireRoutingNumber || !data.bankAddress)) throw new Error('incomplete-wire-details');
  }
  return data;
}
module.exports = { W9_VERSION, W9_CERTIFICATION, TAX_CLASSES, W9_FIELDS, BANK_FIELDS, routingValid, validateForm };
